import axios from 'axios';
import { API_ORIGIN } from '../config';
import { attachAuthInterceptors } from '../services/authTokenRefresh';

const instance = axios.create({
  baseURL: API_ORIGIN,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

attachAuthInterceptors(instance);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error);
    if (error.response) {
      console.error('Status:', error.response.status);
      console.error('Data:', error.response.data);
    }
    return Promise.reject(error);
  }
);

export default instance; 